import { render, staticRenderFns } from "./UnderwriterModal.vue?vue&type=template&id=02bc2fc8&scoped=true"
import script from "./UnderwriterModal.vue?vue&type=script&lang=js"
export * from "./UnderwriterModal.vue?vue&type=script&lang=js"
import style0 from "./UnderwriterModal.vue?vue&type=style&index=0&id=02bc2fc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bc2fc8",
  null
  
)

export default component.exports